export default __webpack_public_path__ + "static/media/Gif_ChemistER.350a1c9a.gif";